import { render, staticRenderFns } from "./HistorialImagenes.vue?vue&type=template&id=187f94dd"
import script from "./HistorialImagenes.vue?vue&type=script&lang=js"
export * from "./HistorialImagenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports